import React from 'react'
import {withTheme} from 'styled-components'

import Container from '../../common/components/Container'

const ClickIcon = ({theme}) => (
  <Container width="1rem" height="1.334rem" marginBottom="0.334rem">
    <svg width="18" height="24" viewBox="0 0 18 24">
      <g fill="none" fillRule="evenodd" stroke={theme.colors.primary} strokeLinecap="round" strokeLinejoin="round">
        <path d="M8.8.5v2.23M2.93 2.93l1.576 1.576M14.667 2.93l-1.576 1.576M.5 8.799h2.23M14.87 8.799h2.228M8.679 23.607c-.544-1.09-2.721-1.701-3.469-3.401-.748-1.701-1.593-3.08-2.169-4.014-.948-1.542.657-2.697 2.017-1.542 1.36 1.156 2.329 2.97 2.397 1.542.068-1.428.025-7.88.082-8.694.126-1.753 2.526-1.88 2.639-.134.102 1.574.275 5.087.275 5.561.749-1.088 2.449-.748 2.517.885.952-1.225 2.381-.271 2.244 1.02.82-1.066 1.935-.35 1.935 1.283 0 1.631-.059 2.759-.209 3.48-.43 2.064-1.905 2.244-1.905 4.08"/>
      </g>
    </svg>
  </Container>
)

export default withTheme(ClickIcon)



// WEBPACK FOOTER //
// ./assets/interview/images/ClickIcon.js